export default __webpack_public_path__ + "static/media/LEFT-P14-3mm.342758f5.dwg";